import { transportationRidesharingComponent } from './transportation-ridesharing.component';
import { RidesharingService } from './transportation-ridesharing.service';

export const transportationRidesharing = angular
     .module('components.transportationRidesharing', [])
     .component('transportationRidesharing', transportationRidesharingComponent)
     .service('RidesharingService', RidesharingService)
     .name;


// WEBPACK FOOTER //
// ./src/app/components/transportation-ridesharing/transportation-ridesharing.module.js